import React from 'react';
import '../../base.scss';
import './ButtonGroup.scss';

export interface ButtonGroupProps {
  /** The content to display inside the button */
  children?: React.ReactNode;
}

export function ButtonGroup({ children }: ButtonGroupProps) {
  return (
    <div className="button-group" role="group">
      {children}
    </div>
  );
}
